import { render } from "./IButton.vue?vue&type=template&id=784287a4"
import script from "./IButton.vue?vue&type=script&lang=js"
export * from "./IButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__